"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alphaColor = void 0;
function alphaColor(color, alpha) {
    const _opacity = Math.round(Math.min(Math.max(alpha || 1, 0), 1) * 255);
    return color + _opacity.toString(16).toUpperCase();
}
exports.alphaColor = alphaColor;
//# sourceMappingURL=colors.js.map